import styled from 'styled-components';
import { POPPINS_FAMILY } from 'styles/poppins_font';

// Alturas espelhadas em .hasAmbassadorBanner (header, layout padrão e styles/global).
export const Container = styled.div`
  height: 52px;
  background: linear-gradient(90deg, #085d47 0%, #098b72 52.404%, #085c45 100%);

  .invite-link {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 100%;
    padding: 0 16px;
    color: ${(props) => props.theme.$white};
    font-family: ${POPPINS_FAMILY};
    font-size: 18px;
    font-weight: 400;
    line-height: normal;
    text-align: center;
    text-decoration: none;

    strong {
      font-weight: 700;
    }

    img {
      flex-shrink: 0;
    }

    .sparkle-mirrored {
      transform: scaleX(-1);
    }
  }

  @media only screen and (max-width: 768px) {
    height: 72px;

    .invite-link {
      font-size: 13px;
    }
  }
`;
